<template>
  <div>
    <div>
      <b-row>
        <b-col>
          <b-button v-on:click="deleteData()" size="sm" variant="outline-light">
            <Icon
              icon="ic:baseline-remove-circle"
              width="20"
              height="20"
              v-b-tooltip.hover.bottom="'Sil'"
              color="#ea5455"
            />
          </b-button>
        </b-col>
        <b-col>
          <b-button
            variant="outline-light"
            size="sm"
            v-on:click="getCardDetay()"
            v-if="
              this.params.data.onay != 'Teklif' &&
              this.params.data.onay != 'Rezerve Edilemedi'
            "
          >
            <Icon
              icon="akar-icons:search"
              width="20"
              height="20"
              v-b-tooltip.hover.bottom="'DETAY'"
              color="#28C76F"
            />
          </b-button>
          <div v-else>
            <p>{{ this.params.data.onay }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon,
  },
  methods: {
    deleteData() {
      this.$root.$emit("deleteCardDetay", this.params.data);
    },
    getCardDetay() {
      this.$root.$emit("getCardDetay", this.params.data);
    },
  },
};
</script>
